const OPEN = 'open';
const CLOSED = 'closed';

const openCollapsible = (trigger, target) => {
  target.setAttribute('aria-expanded', true);
  target.classList.add('is-active');
  trigger.classList.add('is-active');
};

const closeCollapsible = (trigger, target) => {
  target.setAttribute('aria-expanded', false);
  target.classList.remove('is-active');
  trigger.classList.remove('is-active');
};

const restoreCollapible = (trigger, target, state) => {
  if (state === OPEN) {
    openCollapsible(trigger, target);
  } else if (state === CLOSED) {
    closeCollapsible(trigger, target);
  }
};

const getCachedCollapsibleState = (target) => {
  const collapsibles = JSON.parse(localStorage.getItem('collapsibles'));
  return collapsibles[target.id];
};

const cacheCollapsibleState = (target, state) => {
  const collapsibles = JSON.parse(localStorage.getItem('collapsibles'));
  collapsibles[target.id] = state;
  localStorage.setItem('collapsibles', JSON.stringify(collapsibles));
};

const setupCollapsible = (trigger, target) => {
  if (target) {
    if (new Set([...trigger.classList, ...target.classList]).has('is-active')) {
      openCollapsible(trigger, target);
      cacheCollapsibleState(target, OPEN);
    } else {
      closeCollapsible(trigger, target);
      cacheCollapsibleState(target, CLOSED);
    }

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (trigger.classList.contains('is-active')) {
        closeCollapsible(trigger, target);
        cacheCollapsibleState(target, CLOSED);
      } else {
        openCollapsible(trigger, target);
        cacheCollapsibleState(target, OPEN);
      }
    });
  }
};

const setupCollapsibles = () => {
  const triggers = document.querySelectorAll('[data-action="collapse"]');
  console.debug(triggers, 'Collapsible triggers');
  triggers.forEach((trigger) => {
    const target = document.querySelector(trigger.dataset.target);
    if (!target) return;
    const cachedCollapsibleState = getCachedCollapsibleState(target);

    console.debug('cachedCollapsibleState', cachedCollapsibleState);
    if (cachedCollapsibleState) {
      restoreCollapible(trigger, target, cachedCollapsibleState);
    } else {
      setupCollapsible(trigger, target);
    }
  });
};

const clearCollapsiblesInLocalStorage = () => {
  localStorage.setItem('collapsibles', JSON.stringify({}));
};

export { clearCollapsiblesInLocalStorage, setupCollapsibles };
